import { Button } from "../components/Button";
import {  TextField } from "../components/TextField";
import { redirect,  useNavigation } from "react-router-dom";
import { login } from "../services/api";
import { Form } from "react-router-dom";
import mixpanel from "../services/mixpanel";




export async function LoginAction ({request}){
	// throw new Error("we went wrong intensionally");
	// return;
	// console.error("we threw things away");
	// try{

	const data = await request.formData();
	const formToJSON = {};
  for (const [key, value] of [...data.entries()]) {
	formToJSON[key] = value;
  }
	const response = await login(formToJSON);
	// console.log("response", await response.text())


	if (!response.ok) {
		alert("Something went wrong");
		// throw new Error('Network response was not ok');
	}
		const response2 = response.clone();
		try {
			const result = await response.json();
			if(result["token"]){
				const token = result["token"]["token"];
				localStorage.setItem("token", token); // Save token
				//let the user reset their password if it is the default password
				if(result["is_default"] == 1){
					return redirect("/reset_password");
				}
				return redirect("/dashboard");
			}else{
				alert("You entered wrong credentials. try again");
			}
		} catch(e){
			const errorReason = await response2.text();;
			console.error("response text",errorReason);
		}
// } catch(e){

// 	console.log("error", e);
// 	alert(e);
// }
}





export default function (){
	const navigation = useNavigation();
	const isSubmitting = navigation.state == "submitting";

	// function loginAttempt




	return (
		<div id="LoginScreen">

		<h1>Sign In to Dashboard</h1>

		<main>
			<Form  method="post">
				<TextField
					label="Username"
					name="username"
					required = {true}
				/>
				<TextField
					label="Password"
					type="password"
					name="password"
					required={true}
				/>
				<Button
				type="submit"
				disabled={isSubmitting}
				label={ isSubmitting ?"Signing you in....." :"Sign Me In"}
				color="green"
				/>
			</Form>

		</main>
		</div>
	)
}